import * as Jssip from 'jssip';
import { ACTIONTYPE } from '../AppStateProvider';
import { useCallback } from 'react';

export interface SipReport {
  address: string | undefined;
  result: string;
}

export default function useSipConnectivityTest(dispatch: React.Dispatch<ACTIONTYPE>) {
  return useCallback(() => {
    return new Promise(() => {
      try {
        var socketUS = new Jssip.WebSocketInterface(process.env.REACT_APP_SIP_DOMAIN_US!);
        var configurationUS = {
          sockets: [socketUS],
          uri: 'sip:alice@example.com',
          password: 'superpassword',
        };

        var uaUS = new Jssip.UA(configurationUS);

        uaUS.start();

        uaUS.on('connected', function (e) {
          const report: SipReport = { address: socketUS.sip_uri, result: 'Success' };
          dispatch({ type: 'sip-connectivity-us-test-connected' });
          dispatch({ type: 'sip-connectivity-us-test-report', report });
        });

        uaUS.on('disconnected', function (e) {
          const report: SipReport = { address: socketUS.sip_uri, result: 'Failed' };
          dispatch({ type: 'sip-connectivity-us-test-disconnected' });
          dispatch({ type: 'sip-connectivity-us-test-report', report });
        });
      } catch (error: any) {
        const report: SipReport = { address: undefined, result: error.message };
        dispatch({ type: 'sip-connectivity-us-test-disconnected' });
        dispatch({ type: 'sip-connectivity-us-test-report', report });
      }

      try {
        var socketSA = new Jssip.WebSocketInterface(process.env.REACT_APP_SIP_DOMAIN_SA!);
        var configurationSA = {
          sockets: [socketSA],
          uri: 'sip:alice@example.com',
          password: 'superpassword',
        };

        var uaSA = new Jssip.UA(configurationSA);

        uaSA.start();

        uaSA.on('connected', function (e) {
          const report: SipReport = { address: socketSA.sip_uri, result: 'Success SIP connectivity' };
          dispatch({ type: 'sip-connectivity-sa-test-connected' });
          dispatch({ type: 'sip-connectivity-sa-test-report', report });
        });

        uaSA.on('disconnected', function (e) {
          const report: SipReport = { address: socketSA.sip_uri, result: 'Failed SIP connectivity' };
          dispatch({ type: 'sip-connectivity-sa-test-disconnected' });
          dispatch({ type: 'sip-connectivity-sa-test-report', report });
        });
      } catch (error: any) {
        const report: SipReport = { address: undefined, result: error.message };
        dispatch({ type: 'sip-connectivity-sa-test-disconnected' });
        dispatch({ type: 'sip-connectivity-sa-test-report', report });
      }
    });
  }, [dispatch]);
}
